// https://github.com/akveo/ng2-smart-table/issues/305
import { LocalDataSource } from 'ng2-smart-table';
import { Observable } from 'rxjs';

import { HmModelRest, HmRestType } from '../models/abstract_model';
import { HappyMammaService } from './happymamma.service';
import * as _ from 'lodash-es';
import { map } from 'rxjs/operators';

export let prepareLang = (cel: Object, row: any) => cel['it'];
export let filterNumber = (value: string, row?: any) => parseInt(value, 10);
export let filterBoolean = (value: Boolean, row?: any) => value ? 'Sì' : 'No';
export let filterLang = (value: Object, row?: any) => ({ 'it': value });
export let filterText = (value: Object, row?: any) => value;
export let filterLike = (value: Object, row?: any) => '%' + value + '%';
export let preparePregDate = (value: number, row?: any) => {
    //console.log("giorno grav", value, Math.floor(value / 7), value % 7);
    return Math.floor(value / 7)
        + '<sup>' + value % 7 + '</sup>';
};


// export var filterLikeLang = (value: Object, row?: any) =>  { return { 'it' : value } } ;
export let filterLikeLang = (value: Object, row?: any) => ({ 'it': '%' + value + '%' });


export class HMServerSourceConf<T extends HmModelRest> {
    protected static readonly SORT_FIELD_KEY: string;
    protected static readonly SORT_DIR_KEY: string;
    protected static readonly PAGER_PAGE_KEY: string;
    protected static readonly PAGER_LIMIT_KEY: string;
    protected static readonly FILTER_FIELD_KEY: string;
    protected static readonly TOTAL_KEY: string;
    protected static readonly DATA_KEY: string;

    sortFieldKey: string;
    sortDirKey: string;
    pagerPageKey: string;
    pagerLimitKey: string;
    filterFieldKey: string;
    totalKey: string = 'X-total-count';
    dataKey: string;

	/*
	constructor({ basePath, endPoint, sortFieldKey, sortDirKey, pagerPageKey, pagerLimitKey, filterFieldKey, totalKey, dataKey }?: {
	  basePath?: string;
	  endPoint?: string;
	  sortFieldKey?: string;
	  sortDirKey?: string;
	  pagerPageKey?: string;
	  pagerLimitKey?: string;
	  filterFieldKey?: string;
	  totalKey?: string;
	  dataKey?: string;
	})*/
}


export class HMServerDataSource<T extends HmModelRest> extends LocalDataSource {

    public customFilters = [];

    protected conf: HMServerSourceConf<T>;
    protected hmService: HappyMammaService;

    protected lastRequestCount: number;

    protected classType: HmRestType<T>;

    protected isLoading = false;

    protected timeoutHandler: any;
    protected sortConf: Array<any> = [];
    protected filterConf: any = {
        filters: [],
        andOperator: true,
    };

    protected pagingConf: any = {
        display: true,
        perPage: 20,
    };

    constructor(hmService: HappyMammaService, classType: HmRestType<T>, conf: HMServerSourceConf<T> = null) {
        super();

        this.classType = classType;
        this.hmService = hmService;

        this.conf = conf || new HMServerSourceConf<T>();
        this.pagingConf = {
            display: true,
            perPage: 20,
        };

        super.refresh();
    }

    getTypeofProperty<T, K extends keyof T>(o: T, name: K) {
        return typeof o[name];
    }

    protected data: Array<any> = [];

    load(data: Array<any>): Promise<any> {
        return null;
    }

    prepend(element: any): Promise<any> {
        return this.add(element);
    }

    append(element: any): Promise<any> {
        return this.add(element);
    }

    find(element: any): Promise<any> {
        return null;
    }

    getFilteredAndSorted(): Promise<any> {
        return null;
    }
    getAll(): Promise<any> {
        return null;
    }

    reset(silent?: boolean): void {
        return null;
    }

    empty(): Promise<any> {
        return null;
    }

    count(): number {
        return this.lastRequestCount;
    }

    add(element: T): Promise<T> {
        delete element.id;
        return this.hmService.createOrUpdate<T>(element, this.classType).toPromise().then(data => {
            this.refresh();
            return data;
        });
    }

    remove(element: T): Promise<any> {
        return this.hmService.deleteInstance<T>(element.id, this.classType)
            .toPromise().then(data => { this.refresh(); });
    }

    update(element: T, values: T): Promise<T> {

        return this.hmService.createOrUpdate<T>(values, this.classType).toPromise().then(data => {
            this.refresh();
            return data;
        });
    }

    getElements(): Promise<any> {
        return this.requestElements().pipe(map(resp => {
            this.lastRequestCount = resp.tot;
            this.data = resp.data;
            return this.data;
        })).toPromise();
    }

	/**
	 * Extracts array of data from server response
	 * @param res
	 * @returns {any}
	 */
    protected extractDataFromResponse(data: Array<any>): Array<any> {
        return data;

		/* let data = this.conf.dataKey ? getDeepFromObject(rawData, this.conf.dataKey, []) : rawData;

		 if (data instanceof Array) {
		   return data;
		 }

		 throw new Error(`Data must be an array.
		  Please check that data extracted from the server response by the key
		   '${this.conf.dataKey}' exists and is array.`);
		   */
    }

    protected requestElements(): Observable<{ data: T[], tot: number }> {
        const params = this.getQueryParams();
        const body = this.getFilterBody();
        return this.hmService.getAllAndCount(this.classType, body, params.limit, params.offset, params.sort);
    }

    protected getFilterBody(body?: Object): Object {
        body = body || {};

        let filters = [];
        if (this.filterConf.filters) {
            filters = filters.concat(this.filterConf.filters);
        }

        if (this.customFilters) {
            filters = filters.concat(this.customFilters);
        }

        for (const fieldConf of filters) {

            if (fieldConf['search'] !== undefined && fieldConf['search'] !== '') {
                // this.getTypeofProperty(T, 'id')
                if (fieldConf.filter instanceof Function)
                    body[fieldConf.field] = fieldConf.filter(fieldConf.search);
                else if (body[fieldConf.field]) {
                    // stiamo mettendo un custom filter su un valore già filtrato
                    // dobbiamo fare l'intersection del 2 filtri
                    let original_value = body[fieldConf.field];
                    let new_value = fieldConf.search;

                    // dobbiamo modificare solo se sono diversi
                    if (original_value !== new_value) {
                        if (!_.isArray(original_value)) {
                            original_value = [original_value];
                        }
                        if (!_.isArray(new_value)) {
                            new_value = [new_value];
                        }
                        body[fieldConf.field] = _.intersectionWith(original_value, new_value, function (a, b) { return a == b; })
                            ;
                    }
                } else {
                    body[fieldConf.field] = fieldConf.search;
                }
            }
        }

        return body;
    }

    protected getQueryParams(): { sort: string[], limit: number, offset: number } {
        const res = { sort: null, limit: null, offset: null };

        if (this.sortConf && this.sortConf.length) {
            const sort = [];
            this.sortConf.forEach((fieldConf) => {
                let field = fieldConf.field;
                if (fieldConf.direction.toUpperCase() == 'DESC')
                    field = '-' + fieldConf.field;
                sort.push(field);
            });

            res['sort'] = sort;
        } else {
            res['sort'] = ['id'];
        }

        if (this.pagingConf && this.pagingConf['perPage']) {
            res['limit'] = this.pagingConf['perPage'];
            if (this.pagingConf['page']) {
                res['offset'] = (this.pagingConf['page'] - 1) * res['limit'];
            } else {
                res['offset'] = 0;
            }
        }
        return res;
    }


    protected refreshData(action: string): void {
        if (!this.isLoading) {
            this.isLoading = true;

            this.getElements().then((elements) => {
                this.onChangedSource.next({
                    action: action,
                    elements: elements,
                    paging: this.getPaging(),
                    filter: this.getFilter(),
                    sort: this.getSort(),
                });

                this.isLoading = false;
            });
        }
    }
}
